import { Box, Button, Flex, Text, VStack, Image } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import FolderIcon from "assets/img/dashboards/folder.svg";

interface EmptyStateProps {
  onStartOrder: () => void;
}

export const EmptyState = ({ onStartOrder }: EmptyStateProps) => {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minH="calc(100vh - 260px)"
      bg="#F5F7FA"
      border={"1px solid #E6ECF3"}
      borderRadius="16px"
      p="60px 40px"
    >
      <VStack spacing="24px" maxW="500px">
        {/* Folder Icon */}
        <Box>
          <Image src={FolderIcon} width="64px" height="64px" alt="Folder" />
        </Box>

        {/* Text Content */}
        <Box textAlign="center">
          <Text
            fontSize="16px"
            color="#0B0E10"
          >
            You don't have any projects yet.
          </Text>
          <Text
            mt="0px"
            fontSize="16px"
            color="#0B0E10"
          >
            Start your first project by telling us what you need.
          </Text>
        </Box>

        {/* Start Order Button */}
        <Button
          leftIcon={<AddIcon w="14px" h="14px" boxSize="14px" />}
          bgColor="#3A7BFF"
          color="#FFFFFF"
          fontSize="16px"
          fontWeight="600"
          px="16px"
          py="12px"
          h="40px"
          w="152px"
          borderRadius="25px"
          border="1px solid #3A7BFF"
          _hover={{
            bgColor: "#FFFFFF",
            color: "#3A7BFF",
          }}
          _loading={{ pointerEvents: "none" }}
          _active={{
            bgColor: "#FFFFFF",
            color: "#3A7BFF",
          }}
          onClick={onStartOrder}
        >
          Start order
        </Button>
      </VStack>
    </Flex>
  );
};
